import playlistSaga from './playlists/playlistSaga';
import videoSaga from './videos/videoSaga';
import palnChargeSaga from './changecharges/saga'
export default [
    playlistSaga,
    videoSaga,
    palnChargeSaga,
];
